import axios from "axios"
import { 
    PRODUCT_LIST_REQUEST,
    PRODUCT_LIST_SUCCESS,
    PRODUCT_LIST_FAIL ,

    PRODUCT_DETAILS_REQUEST,
    PRODUCT_DETAILS_SUCCESS,
    PRODUCT_DETAILS_FAIL,

    CUSTOMER_LIST_REQUEST,
    CUSTOMER_LIST_SUCCESS,
    CUSTOMER_LIST_FAIL,

    CUSTOMER_POSTLIST_REQUEST,
    CUSTOMER_POSTLIST_SUCCESS,
    CUSTOMER_POSTLIST_FAIL,

    CUSTOMER_DETAILS_REQUEST,
    CUSTOMER_DETAILS_SUCCESS,
    CUSTOMER_DETAILS_FAIL,

    CUSTOMER_UPDATE_REQUEST,
    CUSTOMER_UPDATE_SUCCESS,
    CUSTOMER_UPDATE_FAIL,

    CATEGORY_LIST_REQUEST,
    CATEGORY_LIST_SUCCESS,
    CATEGORY_LIST_FAIL,


  } from "../constants/productConstansts"
  import { BASE_URL } from '../constants/urlConstants'
import axiosInstance from "../utils/axiosInstance"

  export const fetchProducts = (id) => async(dispatch) => {
    try{
        dispatch({type: PRODUCT_LIST_REQUEST})

        const { data } = await axios.get(`${BASE_URL}/products/category/${id}`)
        dispatch({type: PRODUCT_LIST_SUCCESS , payload: data})

    }catch(error){
        dispatch({type: PRODUCT_LIST_FAIL,
            payload: error.response && error.response.data.message
                ? error.response.data.message
                : error.message
        })

    }

  }


  export const fetchProductDetails = (id) => async(dispatch) => {
    try{
        dispatch({type: PRODUCT_DETAILS_REQUEST})
        const { data } = await axios.get(`${BASE_URL}/products/${id}`)
        dispatch({type: PRODUCT_DETAILS_SUCCESS , payload: data})
    }catch(error){
        dispatch({type: PRODUCT_DETAILS_FAIL,
            payload: error.response && error.response.data.detail
                ? error.response.data.detail
                : error.message
        })
    }
  }


  export const fetchCategory = () => async(dispatch) => {
    try{
        dispatch({type: CATEGORY_LIST_REQUEST})

        const { data } = await axios.get(`${BASE_URL}/products/category/`)
        dispatch({type: CATEGORY_LIST_SUCCESS , payload: data})

    }catch(error){
        dispatch({type: CATEGORY_LIST_FAIL,
            payload: error.response && error.response.data.message
                ? error.response.data.message
                : error.message
        })

    }

  }



  export const fetchPaidCustomers = (id, startDate = '', endDate = '') => async (dispatch) => {
    try{
        dispatch({type: CUSTOMER_LIST_REQUEST})

         // ساخت URL با کوئری استرینگ
        const { data } = await axios.get(`${BASE_URL}/customers/${id}/`, {
      params: { start_date: startDate, end_date: endDate }
    })
        dispatch({type: CUSTOMER_LIST_SUCCESS , payload: data})

    }catch(error){
        dispatch({type: CUSTOMER_LIST_FAIL,
            payload: error.response?.data?.detail || error.response?.data?.message || error.message
        })

    }

  }



  export const fetchPostCustomers = (selectedOption) => async(dispatch) => {
    try{
        dispatch({type: CUSTOMER_POSTLIST_REQUEST})

        const { data } = await axios.get(`${BASE_URL}/customers/postlist/${selectedOption}`)
        dispatch({type: CUSTOMER_POSTLIST_SUCCESS , payload: data})

    }catch(error){
        dispatch({type: CUSTOMER_POSTLIST_FAIL,
            payload: error.response && error.response.data.message
                ? error.response.data.message
                : error.message
        })

    }

  }







  export const fetchCustomerDetails = (id) => async(dispatch) => {
    try{
        dispatch({type: CUSTOMER_DETAILS_REQUEST})
        const { data } = await axios.get(`${BASE_URL}/customers/customer/${id}`)
        dispatch({type: CUSTOMER_DETAILS_SUCCESS , payload: data})
    }catch(error){
        dispatch({type: CUSTOMER_DETAILS_FAIL,
            payload: error.response && error.response.data.detail
                ? error.response.data.detail
                : error.message
        })
    }
  }



  export const updateCustomerAction = (customer) => async (dispatch, getState) => {

    try {
        dispatch({
            type: CUSTOMER_UPDATE_REQUEST
        })
        const { userLogin: { userInfo } } = getState()

        const authRequestAxios = axiosInstance(userInfo, dispatch)
        const { data } = await authRequestAxios.put(
            `${BASE_URL}/customers/updatess/`,
            customer,
        )
        dispatch({
            type: CUSTOMER_UPDATE_SUCCESS,
            payload: data
        })
    } catch (error) {
        dispatch({//user update profile fail
            type: CUSTOMER_UPDATE_FAIL,
            payload: error.response && error.response.data.detail
                ? error.response.data.detail
                : error.message
        })
    }

}


  
  
  

  
  

  
  
  
  
  
  

  

  



